import { render, staticRenderFns } from "./MapaCoordenadas.vue?vue&type=template&id=31a87e66&scoped=true&"
import script from "./MapaCoordenadas.vue?vue&type=script&lang=js&"
export * from "./MapaCoordenadas.vue?vue&type=script&lang=js&"
import style0 from "./MapaCoordenadas.vue?vue&type=style&index=0&id=31a87e66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a87e66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VLayout})
